module.exports = __webpack_public_path__ + "img/logo_app.4b23a2d9.png";